import {
    CartItemAddedProductVariantInput,
    CartItemToppingInput,
} from '@/features/graphql/generated/graphql'
import {
    mapFormAddonGroupToCartItemAdditionProductVariants,
    mapFormAddonGroupToCartItemToppings,
} from '@/features/pos/components/Cart/utils/maps'
import { FormAddonGroup } from '@/features/pos/components/ProductConfigurationModal/form/types'

interface CartItemToppingsAndAdditionProductVariants {
    toppingGroupToppings: CartItemToppingInput[]
    additionGroupProductVariants: CartItemAddedProductVariantInput[]
}

export const aggregateAddonGroupsToCartItemToppingsAndAdditionProductVariants = (
    groups: Record<string, FormAddonGroup> | undefined
): CartItemToppingsAndAdditionProductVariants | undefined => {
    if (!groups) return undefined

    const toppingGroupToppings: CartItemToppingInput[] = []
    const additionGroupProductVariants: CartItemAddedProductVariantInput[] = []

    Object.values(groups).forEach((group) => {
        if (group.type === 'topping') {
            toppingGroupToppings.push(...mapFormAddonGroupToCartItemToppings(group))
        }

        if (group.type === 'product') {
            additionGroupProductVariants.push(
                ...mapFormAddonGroupToCartItemAdditionProductVariants(group)
            )
        }
    })

    return { toppingGroupToppings, additionGroupProductVariants }
}
